import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@/shared/shared.module';
import { ComponentModule } from '@/components/component.module';

import { Error404Component } from './error404.component';

@NgModule({
    declarations: [Error404Component],
    imports: [
        CommonModule,
        SharedModule,
        ComponentModule,
        RouterModule.forChild([{ path: '', component: Error404Component }]),
    ],
})
export class Error404Module {}
